// resources/js/Components/Skeletons/SkeletonCard.jsx
export default function SkeletonCard() {
    return (
      <div className="animate-pulse rounded-lg shadow-md bg-white dark:bg-meta-4 p-4">
        <div className="h-40 bg-gray-300 dark:bg-gray-700 rounded mb-4"></div>
        <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded w-3/4 mb-2"></div>
        <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded w-1/2"></div>
      </div>
    );
  }